(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["warrior-push"] && !Shopify.designMode) return;
  try {
    if (document.getElementById("warrior-push-config")) {
/* Warrior Push SDK v5: consent-gated tracking and browser-aware permission prompts. */
(function () {
  "use strict";
  if (window.WarriorPush) return;
  let config, identity, registration, policy, ready, panel, promptTimer, batchTimer;
  let consent = false, queue = [], flushing, stopped = false, workerState = "not_started", promptState = "idle", backgroundTask;
  let cartJobs = Promise.resolve(), lastCartToken = "", clockOffset = 0;
  let pixelSession = "", pixelCartToken = "";
  let activityPage, activityMs = 0, activityLast = 0, activityUntil = 0, activityRunning = false, activityTimer, activitySent = -1;
  const activityClock = () => typeof performance !== "undefined" ? performance.now() : Date.now();
  const foreground = () => document.visibilityState === "visible" && document.hasFocus?.() === true;
  const cookieName = () => "__Host-ww_visitor_" + config.storeId;
  const sessionName = () => "__Host-ww_session_" + config.storeId;
  const pendingKey = () => "ww_withdraw_" + config.storeId;
  const pixelName = () => "__Host-ww_pixel_" + config.storeId;
  function syncPixelBridge() {
    if (!allowed() || stopped || !identity?.pixel || !pixelSession) { cookie(pixelName(),null,0); return; }
    const expires = Number(identity.pixel.expires) - clockOffset;
    if (expires <= Date.now()) { cookie(pixelName(),null,0); return; }
    cookie(pixelName(), { token:identity.pixel.token, expires, session:pixelSession, cartToken:pixelCartToken || undefined,
      productDiagnostics:identity.pixel.productDiagnostics === true, clockOffset }, Math.min(86400,Math.floor((expires-Date.now())/1000)));
  }
  function readCookie(name) {
    try {
      const row = document.cookie.split(";").map(s => s.trim()).find(s => s.startsWith(name + "="));
      return row ? JSON.parse(decodeURIComponent(row.slice(name.length + 1))) : null;
    } catch { return null; }
  }
  function cookie(name, value, maxAge) {
    document.cookie = name + "=" + encodeURIComponent(JSON.stringify(value)) + "; Path=/; Secure; SameSite=Lax; Max-Age=" + maxAge;
  }
  function currentSession() {
    // Shared across tabs; visits count sessions, not page refreshes. No per-second heartbeat.
    let saved = readCookie(sessionName());
    if (!saved || Date.now() - saved.last > 1800000) saved = { id: crypto.randomUUID() };
    saved.last = Date.now();
    cookie(sessionName(), saved, 1800);
    return saved.id;
  }
  function allowed() {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    return consent && !!privacy && privacy.analyticsProcessingAllowed() && privacy.marketingAllowed();
  }
  function permission() { return "Notification" in window ? Notification.permission : "unsupported"; }
  function isIOS() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) || (/Mac/.test(navigator.userAgent) && navigator.maxTouchPoints > 1);
  }
  function permissionNeedsGesture() {
    const ua = navigator.userAgent;
    // Push capability is checked separately. These engines require an explicit permission click;
    // Chromium can still suppress/quiet a native request, which is not a signal to prompt again.
    return isIOS() || /Firefox|FxiOS/.test(ua) || (/Safari/.test(ua) && !/Chrome|Chromium|CriOS|Edg|OPR|Android/.test(ua));
  }
  function idle(task) {
    const run = () => {
      if (!allowed() || stopped) return;
      backgroundTask = window.requestIdleCallback ? window.requestIdleCallback(task, { timeout: 2000 }) : setTimeout(task, 100);
    };
    if (document.readyState === "complete") run();
    else window.addEventListener("load", run, { once: true });
  }
  function stopBackground() {
    if (window.cancelIdleCallback) window.cancelIdleCallback(backgroundTask);
    else clearTimeout(backgroundTask);
  }
  async function boundedFetch(url, options) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 8000);
    try { return await fetch(url, { ...options, signal: controller.signal }); }
    finally { clearTimeout(timer); }
  }
  async function request(path, body, credentials, keepalive = false) {
    const response = await boundedFetch(config.apiBase + "/push/public/" + config.storeId + path, {
      method: "POST", credentials: "omit", keepalive,
      headers: { "Content-Type": "application/json", ...(credentials ? { Authorization: "Bearer " + credentials.token } : {}) },
      body: JSON.stringify(body),
    });
    if (!response.ok) {
      const error = new Error("Warrior Push request failed (" + response.status + ")");
      error.status = response.status; throw error;
    }
    return response.json();
  }
  function emit(kind, data, context) {
    if (!identity || !allowed() || stopped) return Promise.resolve({ recorded: false });
    const event = { ...data, kind, id: crypto.randomUUID(), session: context?.session || currentSession(), ...(context?.id ? { id: context.id } : {}), url: location.origin + location.pathname };
    if (new TextEncoder().encode(JSON.stringify(event)).length > 12000) return Promise.reject(new Error("Event too large"));
    if (queue.length >= 100) return Promise.reject(new Error("Tracking queue full"));
    const result = new Promise((resolve, reject) => queue.push({ event, resolve, reject }));
    if (queue.length >= 20) void flush().catch(() => {});
    else if (!batchTimer) batchTimer = setTimeout(() => { batchTimer = null; void flush().catch(() => {}); }, 800);
    return result;
  }
  function recordCart(kind) {
    // Serialize reads so slower snapshots cannot overtake newer cart observations.
    cartJobs = cartJobs.catch(() => {}).then(async () => {
      if (!allowed() || !identity || stopped) return;
      const observedMs = Date.now() + clockOffset;
      const response = await boundedFetch((window.Shopify.routes?.root || "/") + "cart.js", { credentials: "same-origin" });
      if (!response.ok) throw new Error("Cart unavailable");
      const cart = await response.json();
      lastCartToken = String(cart.token || "").split("?")[0];
      if (!lastCartToken) return;
      const result = await emit(kind, { cartToken:lastCartToken, observedMs, items:(cart.items || []).slice(0,100).map(i=>({variantId:String(i.variant_id),quantity:i.quantity})) });
      pixelCartToken = lastCartToken; syncPixelBridge(); return result;
    });
    return cartJobs;
  }
  async function checkoutStarted(options = {}) {
    if (!allowed() || !identity || stopped) return { recorded:false };
    const observedMs = Date.now() + clockOffset;
    if (!lastCartToken) await recordCart("cart_observed");
    const checkoutToken = typeof options.checkoutToken === "string" ? options.checkoutToken.slice(0,255) : "";
    if (!lastCartToken && !checkoutToken) return { recorded:false };
    const event = emit("checkout_started", { observedMs,...(lastCartToken?{cartToken:lastCartToken}:{}),...(checkoutToken?{checkoutToken}:{}),source:options.source === "checkout_analytics" ? "checkout_analytics" : "checkout_callback" });
    // A checkout navigation can unload the page immediately. Flush without delaying checkout.
    void flush().catch(() => {});
    return event;
  }
  function sampleActivity() {
    const now = activityClock(), elapsed = now - activityLast;
    // A suspended/throttled page cannot prove attention during the missing interval.
    if (activityRunning && elapsed >= 0 && elapsed <= 45000)
      activityMs += Math.max(0, Math.min(now, activityUntil) - activityLast);
    activityLast = now;
    if (now >= activityUntil) activityRunning = false;
  }
  function reportActivity() {
    if (!activityPage || !allowed() || stopped) return;
    const activeMs = Math.min(30 * 86400000, Math.floor(activityMs));
    if (activeMs === activitySent) return;
    activitySent = activeMs;
    void emit("active_time", { activity: { pageId: activityPage.id, activeMs } }, { session: activityPage.session }).catch(() => {
      // A later cumulative report repairs failed/reordered requests without adding time twice.
      if (activitySent === activeMs) activitySent = -1;
    });
  }
  function scheduleActivity() {
    clearTimeout(activityTimer); activityTimer = null;
    if (!activityRunning || !allowed() || stopped) return;
    activityTimer = setTimeout(() => {
      activityTimer = null; sampleActivity();
      if (!foreground()) activityRunning = false;
      reportActivity();
      if (activityRunning) currentSession();
      scheduleActivity();
    }, 30000);
  }
  function startActivityPage() {
    activityPage = { id: crypto.randomUUID(), session: currentSession() };
    activityMs = 0; activitySent = -1; activityLast = activityClock(); activityUntil = activityLast + 60000;
    activityRunning = foreground();
    const first = emit("page_viewed", {}, activityPage);
    reportActivity(); scheduleActivity();
    return first;
  }
  function wakeActivity() {
    if (!activityPage || !identity || !allowed() || stopped || !foreground()) return;
    sampleActivity();
    if (!activityRunning && currentSession() !== activityPage.session) {
      reportActivity(); void startActivityPage().catch(() => {});
    }
    activityUntil = activityClock() + 60000; activityRunning = true;
    // Pointer/scroll events only update the local idle deadline; no request per interaction.
    if (!activityTimer) scheduleActivity();
  }
  function pauseActivity() {
    sampleActivity(); activityRunning = false;
    clearTimeout(activityTimer); activityTimer = null;
    reportActivity(); void flush(true).catch(() => {});
  }
  async function flush(keepalive = false) {
    // Navigation must still send newly queued events while a previous batch is in flight.
    if (flushing && !keepalive) return flushing;
    if (!queue.length || !allowed() || !identity) return;
    clearTimeout(batchTimer); batchTimer = null;
    const batch = []; let bytes = 0;
    while (queue.length && batch.length < 20) {
      const size = new TextEncoder().encode(JSON.stringify(queue[0].event)).length;
      if (batch.length && bytes + size > 45000) break;
      bytes += size; batch.push(queue.shift());
    }
    const credentials = identity;
    const task = (async () => {
      try {
        const result = await request("/" + credentials.id + "/batch", { events: batch.map(b => b.event) }, credentials, keepalive);
        const pages = batch.filter(b => b.event.kind === "page_viewed");
        if (pages.length) { pixelSession = pages[pages.length-1].event.session; syncPixelBridge(); }
        batch.forEach(b => b.resolve(result));
      } catch (error) {
        // Retain the same event IDs for a bounded retry: a lost response cannot double-count a visit.
        if ((!error.status || error.status === 429 || error.status >= 500) && !keepalive && !stopped && allowed() && batch.every(b => (b.attempts || 0) < 2)) {
          batch.forEach(b => b.attempts = (b.attempts || 0) + 1);
          queue.unshift(...batch);
        } else batch.forEach(b => b.reject(error));
      } finally {
        if (flushing === task) flushing = null;
        if (queue.length && allowed() && !stopped) batchTimer = setTimeout(() => { batchTimer = null; void flush().catch(() => {}); }, 1500 + Math.random() * 1000);
      }
    })();
    flushing = task;
    return task;
  }
  async function setupWorker() {
    workerState = "unsupported";
    if (!("serviceWorker" in navigator) || !("PushManager" in window) || !("Notification" in window) || !config.workerUrl || !identity.vapidPublicKey) return false;
    // iPhone/iPad browser tabs cannot subscribe; the installed web app can.
    if (isIOS() && !navigator.standalone && !window.matchMedia?.("(display-mode: standalone)").matches) return false;
    const worker = new URL(config.workerUrl, location.href);
    if (worker.origin !== location.origin) throw new Error("Service worker must use the storefront origin");
    const scope = new URL("./", worker).href;
    const existing = await navigator.serviceWorker.getRegistrations();
    if (existing.some(r => r.scope === scope && [r.active, r.installing, r.waiting].some(w => w && w.scriptURL !== worker.href))) {
      workerState = "scope_conflict";
      throw new Error("Another service worker already uses this scope");
    }
    workerState = "registering";
    registration = await navigator.serviceWorker.register(worker.href);
    if (!registration.active) await new Promise((resolve, reject) => {
      const timer = setTimeout(() => reject(new Error("Worker activation timeout")), 15000);
      const pending = registration.installing || registration.waiting;
      if (!pending) { clearTimeout(timer); reject(new Error("No installing worker")); return; }
      pending.addEventListener("statechange", () => {
        if (pending.state === "activated") { clearTimeout(timer); resolve(); }
      });
    });
    workerState = "active";
    return true;
  }
  async function syncSubscription() {
    if (!identity || !allowed()) throw new Error("Tracking consent required");
    const padded = identity.vapidPublicKey.replace(/-/g,"+").replace(/_/g,"/");
    const key = Uint8Array.from(atob(padded + "=".repeat((4 - padded.length % 4) % 4)), c => c.charCodeAt(0));
    const subscription = (await registration.pushManager.getSubscription()) || (await registration.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: key }));
    if (!allowed() || !identity) return { subscribed: false };
    await request("/" + identity.id + "/subscribe", subscription.toJSON(), identity);
    return { permission: "granted", subscribed: true };
  }
  async function subscribe() {
    if (!allowed() || !identity || !registration?.active) throw new Error("Push is not ready");
    if (permission() === "denied") return { permission: "denied" };
    // Custom/button flows call this directly on click. Timed native requests are best effort;
    // the browser may require a gesture or use quiet UI and we cannot override that decision.
    const result = permission() === "granted" ? "granted" : await Notification.requestPermission();
    if (result !== "granted") {
      if (identity) await request("/" + identity.id + "/resume", { permission: result }, identity);
      return { permission: result };
    }
    return syncSubscription();
  }
  function closePrompt() { panel?.remove(); panel = null; }
  async function showPrompt() {
    if (!allowed() || stopped || document.visibilityState === "hidden" || !registration?.active || permission() !== "default" || !policy?.enabled) return;
    const prompt = { id: crypto.randomUUID(), session: currentSession(), requiresGesture: permissionNeedsGesture() };
    const result = await request("/" + identity.id + "/prompt", { ...prompt, action: "claim" }, identity);
    if (!result.eligible || !allowed() || stopped || document.visibilityState === "hidden") return;
    const current = result.prompt || policy;
    const outcome = action => identity ? request("/" + identity.id + "/prompt", { ...prompt, action }, identity).catch(() => {}) : Promise.resolve();
    if ((current.mode || "native") === "native" && !prompt.requiresGesture) {
      promptState = "native_requested";
      try {
        const r = await subscribe();
        promptState = r.permission === "default" ? "dismissed_or_suppressed" : r.permission;
        await outcome(promptState);
      } catch { promptState = "error"; await outcome("error"); }
      return;
    }
    promptState = "custom_shown";
    panel = document.createElement("section");
    panel.setAttribute("role", "region"); panel.setAttribute("aria-label", "Notification preferences");
    panel.style.cssText = "position:fixed;max-width:340px;width:calc(100% - 40px);box-sizing:border-box;padding:20px;border:1px solid #d9e5dd;border-radius:14px;box-shadow:0 8px 35px #0003;z-index:2147483000;font:15px/1.5 system-ui";
    panel.style[current.position?.startsWith("top") ? "top" : "bottom"] = "20px";
    panel.style[current.position?.endsWith("left") ? "left" : "right"] = "20px";
    panel.style.backgroundColor = current.backgroundColor || "#ffffff"; panel.style.color = current.textColor || "#18251e";
    const title = document.createElement("strong"); title.textContent = current.title || "Warrior World updates";
    const description = document.createElement("p"); description.textContent = current.description || "Get offers and product updates through notifications.";
    const enable = document.createElement("button"); enable.textContent = current.allowLabel || "Enable notifications";
    const later = document.createElement("button"); later.textContent = current.laterLabel || "Later";
    for (const button of [enable,later]) { button.type = "button"; button.style.cssText = "padding:10px 12px;margin:4px 8px 0 0;border:1px solid #c7d8cc;border-radius:8px;cursor:pointer"; }
    enable.style.backgroundColor = current.buttonColor || "#164e37"; enable.style.color = current.buttonTextColor || "#ffffff";
    later.addEventListener("click", () => { promptState = "later"; closePrompt(); void outcome("later"); });
    enable.addEventListener("click", () => {
      enable.disabled = true; later.disabled = true;
      void subscribe().then(r => { promptState = r.permission; closePrompt(); return outcome(r.permission === "granted" ? "granted" : r.permission === "denied" ? "denied" : "dismissed"); }).catch(() => {
        enable.disabled = true; later.disabled = false; description.textContent = "Could not enable notifications. Please try again later.";
        promptState = "error"; void outcome("error");
      });
    });
    panel.append(title,description,enable,later); document.body.appendChild(panel);
  }
  async function identify() {
    if (!config.identityProxyUrl || !identity || !allowed()) return { identified: false };
    const url = new URL(config.identityProxyUrl,location.href);
    if (url.origin !== location.origin) throw new Error("Identity proxy must use storefront origin");
    const digest = new Uint8Array(await crypto.subtle.digest("SHA-256",new TextEncoder().encode(identity.token)));
    url.searchParams.set("ww_visitor",identity.id);
    url.searchParams.set("ww_credential",Array.from(digest,b=>b.toString(16).padStart(2,"0")).join(""));
    const response = await boundedFetch(url.href,{method:"POST",credentials:"same-origin",headers:{"Content-Type":"application/json"},body:JSON.stringify({storeId:config.storeId,visitorId:identity.id,token:identity.token})});
    if (!response.ok) throw new Error("Verified customer linkage unavailable");
    return response.json();
  }
  async function begin() {
    if (!allowed()) throw new Error("Analytics and marketing consent required");
    stopped = false;
    // Only pending withdrawal uses localStorage. Never restore a deleted identity cookie from another store.
    const pending = localStorage.getItem(pendingKey());
    if (pending) { identity = JSON.parse(pending); await withdraw(); throw new Error("Previous consent withdrawal completed; enable again"); }
    identity = readCookie(cookieName());
    if (identity) {
      try { Object.assign(identity, await request("/" + identity.id + "/resume", { permission: permission() }, identity)); }
      catch (error) { if (error.status === 403) cookie(cookieName(), null, 0); throw error; }
    } else {
      const ua = navigator.userAgent;
      const ios = /iPad|iPhone|iPod/.test(ua) || (/Mac/.test(ua) && navigator.maxTouchPoints > 1);
      identity = await request("/bootstrap", {
        consent: true, version: "2026-09", device: ios || /Android|Mobile/i.test(ua) ? "mobile" : "desktop",
        browser: /Edg/.test(ua) ? "Edge" : /Firefox|FxiOS/.test(ua) ? "Firefox" : /Chrome|CriOS/.test(ua) ? "Chrome" : /Safari/.test(ua) ? "Safari" : "Other",
        os: ios ? "iOS" : /Android/.test(ua) ? "Android" : /Windows/.test(ua) ? "Windows" : /Mac/.test(ua) ? "macOS" : "Other",
        locale: navigator.language, permission: permission(), timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      });
      if (!allowed() || stopped) { await request("/" + identity.id + "/withdraw", {}, identity); identity = null; return { supported: false }; }
      cookie(cookieName(), { id: identity.id, token: identity.token }, 31536000);
    }
    if (!allowed() || stopped) return { supported: false };
    clockOffset = Number(identity.serverTimeMs || Date.now()) - Date.now();
    pixelSession = ""; pixelCartToken = ""; syncPixelBridge();
    policy = identity.prompt;
    const first = startActivityPage(); void flush(); await first;
    // Neither cart fetch nor worker registration delays the initial visitor/page record.
    idle(() => {
    if (!allowed() || stopped) return;
    void identify().catch(() => {});
    void recordCart("cart_observed").catch(() => {});
    void setupWorker().then(supported => {
      if (!supported || !allowed() || stopped) return;
      if (permission() === "granted") void syncSubscription().catch(() => {});
      else if (permission() === "default" && policy?.enabled) promptTimer = setTimeout(() => { void showPrompt().catch(() => {}); }, policy.delaySeconds * 1000);
    }).catch(() => { registration = null; if (workerState !== "scope_conflict") workerState = "failed"; });
    });
    return { tracking: true, permission: permission() };
  }
  async function withdraw() {
    consent = false; stopped = true;
    cookie(pixelName(),null,0); pixelSession = ""; pixelCartToken = "";
    clearTimeout(activityTimer); activityTimer = null; activityRunning = false; activityPage = null;
    stopBackground();
    clearTimeout(promptTimer); clearTimeout(batchTimer); closePrompt();
    queue.splice(0).forEach(b => b.resolve({ recorded: false }));
    identity ||= readCookie(cookieName());
    if (identity) {
      localStorage.setItem(pendingKey(), JSON.stringify({ id: identity.id, token: identity.token }));
      await request("/" + identity.id + "/withdraw", {}, identity);
    }
    cookie(cookieName(), null, 0); cookie(sessionName(), null, 0);
    localStorage.removeItem(pendingKey());
    identity = null; ready = undefined; lastCartToken = "";
    if (registration) { const subscription = await registration.pushManager.getSubscription(); if (subscription) await subscription.unsubscribe(); }
  }
  window.WarriorPush = {
    init(options) {
      config = { ...options, apiBase: options.apiBase.replace(/\/$/, "") };
      if (!Number.isInteger(config.storeId) || config.storeId < 1 || new URL(config.apiBase).protocol !== "https:") throw new Error("Valid HTTPS API and store ID required");
    },
    setConsent(value) {
      if (value === true && consent && ready) return ready;
      consent = value === true;
      const start = () => navigator.locks ? navigator.locks.request(cookieName(), begin) : begin();
      ready = (consent ? start() : withdraw()).catch(error => { consent = false; ready = undefined; clearTimeout(activityTimer); activityRunning = false; throw error; });
      return ready;
    },
    subscribe, track: emit, flush, withdraw, identify, checkoutStarted,
    productAlerts() { return identity?.productAlerts || []; },
    async watchOptions(productId) {
      if (!identity || !allowed()) return { kinds:[],variants:[] };
      return request("/"+identity.id+"/watch-options",{productId:String(productId)},identity);
    },
    async watchProduct(kind, productId, variantId) {
      if (!identity || !allowed()) throw new Error("Consent required");
      // Invoke this method directly from a click, so the browser's permission request keeps user activation.
      if(permission() !== "granted") await subscribe();
      else await syncSubscription();
      return request("/"+identity.id+"/watch",{kind,productId:String(productId),variantId:String(variantId)},identity);
    },
    status() { return { tracking: !!identity && allowed() && !stopped, permission: permission(), worker: workerState, prompt: promptState, promptMode: policy?.mode || "native",
      effectivePromptMode: policy?.mode === "custom" || permissionNeedsGesture() ? "custom" : "native",
      workerScope: registration?.scope || null, visitorId: allowed() ? identity?.id || null : null }; },
    cartUpdated() { return recordCart("cart_updated"); },
  };
  for (const type of ["pointerdown", "pointermove", "keydown", "scroll", "touchstart"])
    document.addEventListener(type, wakeActivity, { passive: true });
  document.addEventListener("visibilitychange", () => { if (document.visibilityState === "hidden") pauseActivity(); else wakeActivity(); });
  window.addEventListener("focus", wakeActivity);
  window.addEventListener("blur", pauseActivity);
  window.addEventListener("pagehide", () => { pauseActivity(); stopped = true; stopBackground(); clearTimeout(promptTimer); closePrompt(); });
  window.addEventListener("pageshow", event => { if (event.persisted && allowed()) { stopped = false; void startActivityPage().catch(() => {}); } });
  document.addEventListener("visitorConsentCollected", () => { if (config && !allowed() && identity) void withdraw().catch(() => {}); });
})();

(function () {
  "use strict";
  const element = document.getElementById("warrior-push-config");
  if (!element || !window.WarriorPush || window.__warriorPushThemeInstalled) return;
  const data = element.dataset;
  if (location.origin !== data.origin || window.Shopify?.designMode) return;
  window.__warriorPushThemeInstalled = true;
  const sdk = window.WarriorPush;
  sdk.init({ storeId: Number(data.storeId), apiBase: data.apiBase,
    workerUrl: data.proxyBase + "/warrior-push-sw.js", identityProxyUrl: data.proxyBase + "/identity" });
  let permitted = false, productRecorded = false, syncing = Promise.resolve();
  function syncConsent() {
    // Serialize consent changes, including a withdrawal while bootstrap is in flight.
    syncing = syncing.catch(() => {}).then(async () => {
      const privacy = window.Shopify?.customerPrivacy;
      const next = !!privacy?.analyticsProcessingAllowed() && !!privacy?.marketingAllowed();
      if (!next) { permitted = false; productRecorded = false; await sdk.setConsent(false); return; }
      const result = await sdk.setConsent(true);
      permitted = !!result.tracking;
      if (permitted && data.productId && !productRecorded) {
        productRecorded = true;
        void mountProductAlerts().catch(()=>{});
        await sdk.track("product_viewed", { product: { id: data.productId,
          title: data.productTitle, url: new URL(data.productUrl, location.origin).href } });
      }
    }).catch(() => { permitted = false; });
  }
  document.addEventListener("visitorConsentCollected", syncConsent);
  if (window.Shopify?.customerPrivacy) syncConsent();
  else if (window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], error => { if (!error) syncConsent(); });

  async function mountProductAlerts() {
    if (!data.productId || !sdk.productAlerts?.().length || document.getElementById("warrior-product-alerts")) return;
    const options=await sdk.watchOptions(data.productId);
    if (!permitted || !options.variants.length) return;
    const root=document.createElement("div");root.id="warrior-product-alerts";
    const mobile=window.matchMedia("(max-width: 640px)"),positions=[],groups=new Map();
    const cleanColor=(value,fallback)=>/^#[0-9a-fA-F]{6}$/.test(value || "")?value:fallback;
    options.kinds.forEach(kind=>{
      const settings=options.widgets?.[kind] || {};
      const stock=kind==="back_in_stock",label=stock?"Back in stock":"Price drop";
      const box=document.createElement("details"),toggle=document.createElement("summary"),content=document.createElement("div");
      box.setAttribute("aria-label",label+" notifications");toggle.textContent=label+" alerts";
      const bg=cleanColor(settings.background,"#ffffff"),color=cleanColor(settings.color,"#18251e");
      Object.assign(box.style,{background:bg,color,padding:"12px",border:"1px solid #d8e3d9",borderRadius:"12px",width:"min(290px, calc(100vw - 40px))",boxShadow:"0 6px 24px #0002",fontFamily:"inherit"});
      Object.assign(toggle.style,{cursor:"pointer",fontWeight:"600"});
      const position=()=>{
        const value=(mobile.matches?settings.mobilePosition:settings.position)||settings.position||"bottom-left";
        let group=groups.get(value);
        if(!group){
          group=document.createElement("div");groups.set(value,group);
          const [vertical,horizontal]=value.split("-");
          Object.assign(group.style,{position:"fixed",zIndex:"999",display:"flex",flexDirection:"column",gap:"8px",maxHeight:"calc(100vh - 40px)",overflowY:"auto",padding:"4px"});
          group.style[vertical==="top"?"top":"bottom"]="20px";
          group.style[horizontal==="right"?"right":"left"]=horizontal==="center"?"50%":"16px";
          if(vertical==="center"){group.style.top="50%";group.style.bottom="auto";group.style.transform="translateY(-50%)";}
          if(horizontal==="center")group.style.transform="translateX(-50%)";
          root.appendChild(group);
        }
        group.appendChild(box);
      };
      const before=document.createElement("p"),select=document.createElement("select"),button=document.createElement("button"),status=document.createElement("p");
      before.textContent=settings.before || (stock?"Get a notification when this option is back in stock.":"Get a notification when this option's price drops.");
      select.setAttribute("aria-label",label+" product option");
      options.variants.forEach(v=>{const o=document.createElement("option");o.value=v.id;o.textContent=v.title||"Default option";select.appendChild(o);});
      const chosen=new URL(location.href).searchParams.get("variant") || document.querySelector('form[action*="/cart/add"] [name="id"]')?.value;
      if(options.variants.some(v=>v.id===chosen))select.value=chosen;
      status.setAttribute("role","status");button.type="button";button.textContent=settings.button||"Notify me";
      Object.assign(button.style,{background:color,color:bg,border:"0",borderRadius:"7px",padding:"10px 14px",width:"100%",marginTop:"12px",cursor:"pointer"});
      Object.assign(select.style,{width:"100%",padding:"8px",background:bg,color,border:"1px solid #ccc",borderRadius:"6px"});
      const refresh=()=>{const variant=options.variants.find(v=>v.id===select.value);button.hidden=stock&&variant?.inStock;
        before.textContent=(settings.before || (stock?"Get a notification when this option is back in stock.":"Get a notification when this option's price drops.")).replaceAll("{"+"{variant_price}"+"}",variant?.price||"");
        status.textContent=button.hidden?"This option is already available.":"";};
      refresh();select.addEventListener("change",refresh);
      // Do not show a back-in-stock flyout if every option is already available.
      if(stock&&options.variants.every(v=>v.inStock))return;
      position();positions.push(position);mobile.addEventListener?.("change",position);
      button.onclick=()=>{button.disabled=true;void sdk.watchProduct(kind,data.productId,select.value).then(()=>{before.hidden=true;select.hidden=true;button.hidden=true;status.textContent=settings.after||"You're on the list. We'll notify you.";}).catch(()=>{status.textContent="Alert not enabled. Check browser permission or try again later.";}).finally(()=>{button.disabled=false;});};
      content.append(before,select,button,status);box.append(toggle,content);
    });
    document.body.appendChild(root);
    const cleanUp=()=>{const p=window.Shopify?.customerPrivacy;if(!p?.analyticsProcessingAllowed() || !p?.marketingAllowed()){
      root.remove();positions.forEach(fn=>mobile.removeEventListener?.("change",fn));document.removeEventListener("visitorConsentCollected",cleanUp);
    }};
    document.addEventListener("visitorConsentCollected",cleanUp);
  }

  let cartTimer;
  function cartChanged() {
    if (!permitted) return;
    clearTimeout(cartTimer);
    cartTimer = setTimeout(() => { void sdk.cartUpdated().catch(() => {}); }, 200);
  }
  const isCartMutation = (input, method) => {
    try {
      const url = new URL(typeof input === "string" || input instanceof URL ? input : input.url, location.href);
      return url.origin === location.origin && String(method || "GET").toUpperCase() === "POST" && /\/cart\/(add|change|update|clear)(\.js)?$/.test(url.pathname);
    } catch { return false; }
  };
  const originalFetch = window.fetch;
  window.fetch = function (input, options) {
    const response = originalFetch.apply(this, arguments);
    if (isCartMutation(input, options?.method || input?.method)) void response.then(r => { if (r.ok) cartChanged(); }, () => {});
    return response;
  };
  const originalOpen = XMLHttpRequest.prototype.open, originalSend = XMLHttpRequest.prototype.send;
  const mutations = new WeakMap();
  XMLHttpRequest.prototype.open = function (method, url) {
    const result = originalOpen.apply(this, arguments);
    mutations.set(this, isCartMutation(url, method));
    return result;
  };
  XMLHttpRequest.prototype.send = function () {
    if (mutations.get(this)) this.addEventListener("load", () => { if (this.status >= 200 && this.status < 300) cartChanged(); }, { once: true });
    return originalSend.apply(this, arguments);
  };
  document.addEventListener("warrior:cart-updated", cartChanged);
  // Checkout callbacks are activity signals, never purchase authority. Do not infer
  // checkout from arbitrary button clicks, iframe presence, or cross-origin messages.
  document.addEventListener("warrior:checkout-started", event => {
    if (permitted) void sdk.checkoutStarted({ checkoutToken:event.detail?.checkoutToken }).catch(() => {});
  });
  // GA4 integrations (including Fastrr) may emit begin_checkout in the top window.
  // Observe new events only; replaying the old dataLayer would invent activity.
  try {
    const layer = window.dataLayer = window.dataLayer || [];
    const originalPush = layer.push;
    if (typeof originalPush === "function") layer.push = function () {
      const result = originalPush.apply(this, arguments);
      try {
        if (permitted) for (const entry of arguments) {
          if (entry?.event === "begin_checkout" || (entry?.[0] === "event" && entry?.[1] === "begin_checkout"))
            void sdk.checkoutStarted({source:"checkout_analytics"}).catch(() => {});
        }
      } catch { /* Tracking must never interrupt another analytics integration. */ }
      return result;
    };
  } catch { /* A protected data layer remains untouched; use the documented callback. */ }
})();

}
  } catch(e) { console.error(e); }
})();

})();
